import React from "react"
import { injectIntl } from "react-intl"
import Toggle from "react-toggle"
import { useGetPaymentAccounts } from "../../payment-processing/usePaymentAccountSession"
import IntlProps from "../../state/helpers/IntlProps"
import { PAYMENT_TYPE } from "../../state/helpers/Payment"
import { messages } from "./messages"

type OwnProps = {
    toggled: boolean
    selectedPaymentMethod: string
    loading: boolean
    onToggle: () => void
    onSelectPaymentMethod: (method: string) => void
}

const PaymentMethodSelector = (props: OwnProps & IntlProps) => {
    const { hasActiveAccount } = useGetPaymentAccounts()

    return (
        <>
            <div className="w-100 d-flex">
                <div className="mr-2">
                    <Toggle
                        id="capturePayment"
                        defaultChecked={props.toggled}
                        checked={props.toggled}
                        icons={false}
                        disabled={props.loading}
                        onChange={props.onToggle} />
                </div>
                <label htmlFor="capturePayment">
                    {props.intl.formatMessage(messages.togglePaymentCapture)}
                </label>
            </div>
            {props.toggled && (
                <div className="d-flex align-items-center mb-2 ml-4">
                    <label htmlFor="paymentMethod" className="mb-0">
                        {props.intl.formatMessage(messages.paymentMethodSelectLabel)}
                    </label>
                    <select
                        name="paymentMethod"
                        value={props.selectedPaymentMethod}
                        id="paymentMethod"
                        className="form-control ml-2"
                        style={{width: "350px"}}
                        disabled={props.loading || !hasActiveAccount}
                        onChange={e => props.onSelectPaymentMethod(e.target.value)}
                    >
                        <option
                            key={PAYMENT_TYPE.CREDIT_CARD}
                            value={PAYMENT_TYPE.CREDIT_CARD}
                        >
                            {props.intl.formatMessage(messages.creditCard)}
                        </option>
                        {hasActiveAccount && <option
                            key={PAYMENT_TYPE.BANK_TRANSFER}
                            value={PAYMENT_TYPE.BANK_TRANSFER}
                        >
                            {props.intl.formatMessage(messages.ach)}
                        </option>}
                    </select>
                </div>
            )}
        </>
    )
}

export default injectIntl(PaymentMethodSelector)


// WEBPACK FOOTER //
// ./src/common/recurring-options-dropdown/PaymentMethodSelector.tsx